// extracted by mini-css-extract-plugin
export default {"form":"styles_form__Q2oNl","input":"styles_input__t8AAp","buttons":"styles_buttons__6Z4fY"};